import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=0bad9d42"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bad9d42')) {
      api.createRecord('0bad9d42', component.options)
    } else {
      api.reload('0bad9d42', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=0bad9d42", function () {
      api.rerender('0bad9d42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/BarChart.vue"
export default component.exports